<template>
  <div
  class="flag-attivita"
  @click="openModal();"
  >
  <template v-if="attivita.device==='manuale'"> <!--manuale-->

    <div class="evento-attivita"
    :class="classSport"
    >
    <div class="preview">
      <p v-if="attivita.titoloAllenamento" class="attivita-titolo" v-text="attivita.titoloAllenamento"></p>
      <p class="attivita-sport" v-text="attivita.gruppoSport"></p>
      <table class="flag-attivita-dati">
        <tr class="box distanza" v-if="distanza">
          <td class="attivita-dati-value">
            <i class="msp-icon-distance"></i>
            <span v-html="distanza"></span>
          </td>
        </tr>
        <!-- distanza -->

        <tr v-if="totTempo">
            <td class="attivita-dati-value"><i class="msp-icon-time"></i> {{totTempo}}
            </td>
        </tr>
      </table>
    </div>
    
  </div>



</template>

<template v-else> <!--automatico-->
  <div
  class="evento-attivita"
  :class="classSport"
  >
  <div class="preview">
    <p v-if="attivita.titoloAllenamento" class="attivita-titolo" v-text="attivita.titoloAllenamento"></p>
    <p class="attivita-sport" v-text="attivita.sport"></p>
    <table class="flag-attivita-dati">
      <tr class="box distanza">
        <td class="attivita-dati-value">
          <i class="msp-icon-distance"></i>
            <span v-html="distanza"></span>
        </td>
      </tr>
      <!-- distanza -->

      <tr v-if="totTempo">
        <td class="attivita-dati-value"><i class="msp-icon-time"></i> {{totTempo}}
        </td>
      </tr>
      <tr v-if="countBests">
            <td :class="classBests" class="attivita-dati-value"><i class="icon-bests msp-icon-award" /> <span class="small">x</span> {{countBests}} </td>
        </tr>
    </table>
  </div>
</div>

</template>

</div>

</template>

<script>
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import _funzioni from "@src/js/msp/funzioni.js"

export default {
  mixins: [
    allenamentoCalcoli,
  ],

  props: ['item'],

  computed: {
      attivita: function () {
          return this.item.data;
      },
      distanza: function () {
          return this.renderRisultatoBySport({'mt': this.attivita.metri},'distanza','mt',this.attivita.sport_id);
      },
      countBests: function () { 
          if (!(this.attivita && this.attivita.bests)) return false;
          return this.attivita.bests.length;
      },
      classBests: function () {
          if (!this.attivita) {
              return "";
          }
          if (!_funzioni.deepProp(this.attivita,'bests.length')) {
              return "";
          }
          let first = this.attivita.bests.filter(el=>el.posizione == 1);
          if (first.length) {
              return "gold";
          }
          return "";
      },
      classSport: function () {
          if (this.attivita.idSportCP) {
              return 'attivita-sport-'+this.attivita.idSportCP;
          }
          if (this.attivita.gruppoSport) {
              return 'attivita-sport-'+this.attivita.gruppoSport.toLowerCase();
          }
          return '';
      },
      totTempo: function () {
          return this.sec2hms(this.attivita.durata);
      },

  },

  data: function () {
    return {
      active: false
    }
  },
  watch: {

  },
  mounted: function() {

  },
  methods: {
    toggleActive: function ()
    {
      this.active = !this.active;
    },
    openModal: function () {
        this.$emit("open-modal", this.attivita);
    },
  }

}
</script>

<style lang="scss">
.flag-attivita {
  .attivita-sport {
    flex-basis: 15%;
    line-height: 1;
    padding: var(--ui-space);
    color: #fff;
    margin: 0;
    font-size: 0.7em;
  }

  .attivita-titolo {
    padding: var(--ui-space);
    color: #fff;
    margin: 0;
    font-weight: bold;
    flex-basis: 100%;
  }
  .preview {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    table {
      display: flex;
      justify-content: flex-start;
      td {
        background: rgba(255,255,255,0.6);
        padding: 0 var(--ui-space);
      }
    }
    td.gold  {
        background: gold;
    }
  }
  td {
    color: #000;
  }
  --color: var(--col-grigio-chiaro);
  .flag {
    width: 15px;
    height: 20px;
  }
  .flag-attivita-dati {
    td {
      padding: 0.1em;
      background: #fff;
      border-bottom: 1px solid var(--color);
    }
    td.attivita-dati-value {
      font-weight: bold;
    }
  }




  display: flex;
  justify-content: left;
  .flag-sport-1 {
    --color: var(--col-sport-1);
  }
  .flag-sport-2 {
    --color: var(--col-sport-2);
  }
  .flag-sport-3 {
    --color: var(--col-sport-3);
  }
  .flag-sport-4 {
    --color: var(--col-sport-4);
    fill: var(--color);
  }
  .flag {
    color: var(--color);
  }
  .flag-attivita {
    flex: 1;
  }
  .evento-attivita {
    width: 100%;
    background: var(--color);
    position: relative;
    margin-bottom: var(--ui-space);
    --color: #ccc;
    &.attivita-sport-podismo,
    &.attivita-sport-1 {
      --color: var(--col-sport-1);
    }
    &.attivita-sport-ciclismo,
    &.attivita-sport-2 {
      --color: var(--col-sport-2);
    }
    &.attivita-sport-nuoto,
    &.attivita-sport-3 {
      --color: var(--col-sport-3);
    }
    &.attivita-sport-4 {
      --color: var(--col-sport-4);
    }


  }
    .icon-bests {
        --ico-color: var(--col-grigio);
    }
    .small {
        font-size: 0.8em;
    }
}

</style>
